<template>
  <div class="dialog-box gzh-dialog" v-if="isShow" @touchmove.prevent>
    <div class="dialog-mask" @click="hide"></div>
    <div class="dialog" :class="{'dialog-enter-active': isShow}">
      <div class="dialog-content">
        <div class="gzh-desc">
          长按扫码关注戴尔企采网<br/>了解更多企采会员福利
        </div>
        <img class="gzh-img" src="~@/assets/gzh-img.png" alt="">
      </div>
      <div class="dialog-close" @click="hide"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gzh-dialog",
  data() {
    return {
      isShow: false
    };
  },
  mounted() {},
  methods: {
    // 显示弹窗
    show: function () {
      this.isShow = true;
    },
    // 隐藏所有弹窗
    hide: function () {
      this.isShow = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-box {
  width: 100%;
  height: 100%;
  z-index: 2147483601;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;

  .dialog-mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    position: absolute;
    top: 0;
    left: 0;
  }

  .dialog {
    box-sizing: border-box;
    position: relative;
    width: 5.37rem;
    height: 6.52rem;
    padding: .4rem 0 0;
    border-radius: 0;
    box-shadow: none;
    background: url("~@/assets/dialog-gzh-bg.png") no-repeat center center/cover;
    animation: dialog-enter .3s ease-out forwards;

    @keyframes dialog-enter {
      0% {
        transform: translateY(100vh);
      }
      100% {
        transform: translateY(0);
      }
    }

    .dialog-content {
      font-size: .3rem;
      color: #666;
      text-align: center;
      padding: .25rem;

      .gzh-desc {
        margin-bottom: .4rem;
        text-align: center;
        font-size: .26rem;
        color: #a7947e;
      }

      .gzh-img {
        display: block;
        margin: 0 auto;
        width: 4rem;
      }
    }

    .dialog-close {
      position: absolute;
      bottom: -1rem;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      width: .8rem;
      height: .8rem;
      background: url("~@/assets/dialog-close.png") no-repeat center center/cover;
    }
  }
}
</style>